import React, { useState, useEffect, JSX } from 'react';
import chimeLogo from "../assets/Chime2.jpg";
import blogLogo from "../assets/B2.jpg";
import chatLogo from "../assets/CC2.jpg";
interface ModalTriggerProps {
  module: {
    name: string;
    logo?: string | null;
  };
  description: string;
}

function ModalTrigger({ module, description }: ModalTriggerProps): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

const folder = module.name
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

  const images = [
  `/modules/${folder}/1.png`,
  `/modules/${folder}/2.png`,
  `/modules/${folder}/3.png`,
  `/modules/${folder}/4.png`,
  `/modules/${folder}/5.png`,
  `/modules/${folder}/6.png`,
  `/modules/${folder}/7.png`,
];

    useEffect(() => {
        if (!isOpen) return;
        const interval = setInterval(() => {
            setCurrentImageIndex(prev => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [images.length, isOpen]);

    return (
        <>
            {/* Module Box */}
            <div
                onClick={() => setIsOpen(true)}
                style={{
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    padding: '12px',
                    textAlign: 'center',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    transition: '0.3s ease'
                }}
            >
                {module.logo && (
                    <img
                        src={module.logo}
                        alt={module.name}
                        style={{ width: 40, height: 40, objectFit: 'contain', marginBottom: 6 }}
                    />
                )}
                <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{module.name}</div>
                <div style={{ fontSize: '0.75rem', marginTop: 4, color: '#555' }}>{description}</div>
            </div>

            {/* MODAL */}
            {isOpen && (
                <div
                    onClick={() => setIsOpen(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.3)',
                        backdropFilter: 'blur(6px)',
                        zIndex: 999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 20
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: 'white',
                            width: '90%',
                            maxWidth: '900px',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        {/* Left Image Section */}
                        <div style={{ flex: 1, padding: 20, position: 'relative' }}>
                            <img
                            src={images[currentImageIndex]}
                            alt="module slide"
                            className="
                                object-contain 
                                rounded-lg 
                                mx-auto 
                                max-w-[380px] 
                                max-h-[300px] 
                                w-full 
                                h-auto
                            "
                            />


                            <button
                                onClick={() => setCurrentImageIndex(prev => (prev - 1 + images.length) % images.length)}
                                style={{
                                    position: 'absolute',
                                    left: 10,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: '#7b1fa2',
                                    color: 'white',
                                    borderRadius: '50%',
                                    padding: '8px 12px',
                                    cursor: 'pointer'
                                }}
                            >
                                ←
                            </button>

                            <button
                                onClick={() => setCurrentImageIndex(prev => (prev + 1) % images.length)}
                                style={{
                                    position: 'absolute',
                                    right: 10,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: '#7b1fa2',
                                    color: 'white',
                                    borderRadius: '50%',
                                    padding: '8px 12px',
                                    cursor: 'pointer'
                                }}
                            >
                                →
                            </button>
                        </div>

                        {/* Right Description Section */}
                        <div style={{ flex: 1, padding: 20 }}>
                            <h2 style={{ color: '#7b1fa2', fontSize: '1.3rem', fontWeight: 'bold', marginBottom: 10 }}>
                                {module.name}
                            </h2>
                            <p style={{ fontSize: '0.9rem', color: '#444', lineHeight: 1.6 }}>
                                {description}
                            </p>

                            <button
                                onClick={() => alert("Learn More clicked")}
                                style={{
                                    marginTop: 20,
                                    padding: '10px 20px',
                                    background: '#7b1fa2',
                                    color: 'white',
                                    borderRadius: 6,
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: 600
                                }}
                            >
                                Learn More
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}



const Product: React.FC = () => {
    const [colorToggle, setColorToggle] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setColorToggle((prev) => !prev);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    const phase1Modules = [
        { name: 'Chime', logo: chimeLogo },
        { name: 'Blog', logo: blogLogo },
        { name: 'Chat', logo: chatLogo }
    ];

    const phase2Modules = [
        { name: 'ConveyrHealth', logo: 'CH.jpg' },
        { name: 'Conveyr Ecommerce (UrbanGro)', logo: 'UGRO.png' },
        { name: 'ConveyrMusic', logo: 'CM1.jpg' },
        { name: 'ConveyrReelBOX (OTT)', logo: null },
        { name: 'Conveyr Games', logo: null },
        { name: 'ConveyrNews', logo: 'CN3.jpg' },
        { name: 'ConveyrDrive12', logo: 'Drive12.jpg' },
        { name: 'ConveyrBox', logo: null },
        { name: 'ConveyrFinance', logo: 'Cfin.png' },
        {
            name: 'ConveyrFashions (VeritasVogue)',
            logo: 'VV1.jpg',
            isVeritasVogue: true,
            tagline: 'A celebration of authentic style crafted with timeless elegance'
        }
    ];

    const phase1Desc = [
        "A space to express and be heard: A real-time public opinion platform that allows every Indian to share thoughts, perspectives, and reactions with the nation. Powered by AI, it ensures relevance, safety, and informed engagement.",
        "A platform for insights, ideas, and knowledge: A long-form content ecosystem for writers, experts, thinkers, entrepreneurs, and creators. AI assists users with writing, optimizing, and amplifying their voice.",
        "Secure, intelligent communication: End-to-end encrypted messaging strengthened by AI for smart replies, translation, drafting, and contextual assistance—ensuring safe and meaningful interactions."
    ];

    const phase2Desc = [
        "Diagnostics, pathology & future healthcare expansion",
        "A trusted marketplace for buyers & sellers",
        "AI-driven music discovery and streaming",
        "Short and long-form video entertainment",
        "Mobile gaming with AI-driven personalization",
        "Real-time, unbiased, AI-curated news",
        "Secure, India-hosted cloud for files & data",
        "Live channels streamed via secure Indian servers",
        "Provides online payment services, stock market and financing services",
        "A celebration of authentic style crafted with timeless elegance"
    ];

    return (
        <div style={{ display: 'flex', minHeight: 'calc(100vh - 80px)', padding: '40px 20px', gap: '40px', backgroundColor: '#f5f5f5', flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: '40px', width: '100%' }}>
                {/* Left Content - 65% */}
                <div style={{ flex: '0 0 65%', maxWidth: '65%' }}>
                    {/* What is Conveyr Section */}
                    <div style={{ marginBottom: '40px', backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <h2 style={{ color: '#A40000', fontSize: '1.4rem', marginBottom: '20px', fontWeight: 'bold' }}>What is Conveyr?</h2>
                        <h3 style={{ color: '#7b1fa2', fontSize: '1.1rem', marginBottom: '15px', fontWeight: 'bold' }}>Conveyr — India's Sovereign Social Ecosystem</h3>
                        <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333', marginBottom: '12px' }}>
                            Conveyr is India's first fully sovereign digital ecosystem, built to reduce dependency on foreign platforms and ensure data sovereignty. It brings together social networking, content creation, entertainment, commerce, payments, and cloud services—all under one unified Indian platform.
                        </p>
                        <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333', marginBottom: '12px' }}>
                            Unlike fragmented foreign apps, Conveyr offers seamless integration across modules—eliminating the need to switch between multiple platforms. From social interactions to financial transactions, from entertainment to enterprise productivity, Conveyr empowers users with a secure, AI-driven, and truly Indian digital experience.
                        </p>
                        <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
                            With Conveyr, India doesn't just participate in the digital revolution—it leads it.
                        </p>
                    </div>
                    {/* Why Conveyr Section */}
                    <div style={{ marginBottom: '40px', backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <h2 style={{ color: '#A40000', fontSize: '1.4rem', marginBottom: '20px', fontWeight: 'bold' }}>Why Conveyr?</h2>
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.95rem', marginBottom: '8px', fontWeight: 'bold' }}>1. Digital Sovereignty & Data Security</h4>
                            <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
                                India's digital infrastructure should not depend on foreign corporations that mine user data and control narratives. Conveyr ensures that Indian data stays in India, governed by Indian laws, protecting national security and user privacy.
                            </p>
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.95rem', marginBottom: '8px', fontWeight: 'bold' }}>2. Unified Ecosystem — No App-Switching</h4>
                            <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
                                Why juggle between WhatsApp, Instagram, YouTube, Google Drive, Paytm, and Amazon? Conveyr integrates social media, messaging, video streaming, cloud storage, payments, and e-commerce into one seamless platform. One login. One ecosystem. Infinite possibilities.
                            </p>
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.95rem', marginBottom: '8px', fontWeight: 'bold' }}>3. AI-Powered Intelligence</h4>
                            <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
                                Conveyr leverages cutting-edge AI to personalize content, enhance security, optimize user experiences, and drive smarter recommendations—across all modules. AI isn't just a feature; it's the backbone of Conveyr's innovation.
                            </p>
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.95rem', marginBottom: '8px', fontWeight: 'bold' }}>4. Empowering Indian Creators & Businesses</h4>
                            <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
                                Foreign platforms take massive cuts from Indian creators and businesses. Conveyr ensures fair revenue sharing, direct monetization tools, and enterprise-grade features—designed specifically for the Indian market. From content creators to SMEs, Conveyr amplifies Indian entrepreneurship.
                            </p>
                        </div>
                        <div style={{ marginBottom: '0' }}>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.95rem', marginBottom: '8px', fontWeight: 'bold' }}>5. Scalable, Modular, and Future-Ready</h4>
                            <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#333' }}>
                                Conveyr is built on a modular architecture, allowing continuous innovation and expansion. As India's digital needs evolve, Conveyr evolves with them—ensuring long-term relevance and global competitiveness.
                            </p>
                        </div>
                    </div>

                    {/* --- Additive Section: Conveyr & Its Modules (with illustration) --- */}
                    <div style={{
                        marginBottom: '10px',
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',  // ⬅ Center horizontally
                        alignItems: 'flex-start',
                        width: "100%",             // ⬅ Use full width
                        maxWidth: "7000px",        // ⬅ Keep it nicely centered on large screens
                        margin: "0 auto"           // ⬅ Center the whole section
                    }}>
                        <div style={{ flex: 1, minWidth: "250px", textAlign: "left" }}>
                            <h2 style={{ color: '#A40000', fontSize: '1.3rem', marginBottom: '14px', fontWeight: 'bold' }}>Conveyr & Its Modules</h2>
                            <h3 style={{ color: '#7b1fa2', fontSize: '1.04rem', marginBottom: '12px', fontWeight: 'bold' }}>Conveyr: The Super-App Ecosystem Redefining Digital Living</h3>
                            <p style={{ fontSize: '0.84rem', lineHeight: '1.55', color: '#333', marginBottom: '11px' }}>
                                Conveyr is not a single-service product — it is a unified Super Application designed to seamlessly integrate communication, content, commerce, and healthcare into one intelligent digital ecosystem. Each module is intentionally engineered to complement the others, creating a platform where users move naturally across services — driving organic engagement, retention, and monetization.<br /><br />
                                Instead of offering multiple disconnected features, Conveyr connects essential digital experiences into a cohesive, AI-powered environment. This interlinked architecture is the foundation of the platform — removing modules doesn’t simplify the model; it disrupts the synergy that makes Conveyr powerful.
                            </p>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.93rem', marginBottom: '7px', fontWeight: 600 }}>
                                The Synergy That Powers Conveyr
                            </h4>
                            <p style={{ fontSize: '0.84rem', lineHeight: '1.55', color: '#333', marginBottom: '9px' }}>
                                Conveyr’s strength lies in how each vertical fuels the others, creating a self-reinforcing, scalable loop of user growth and revenue generation:
                            </p>
                            <ul style={{ margin: 0, paddingLeft: 22, marginBottom: '9px', fontSize: '0.85rem', color: '#333', lineHeight: '1.5' }}>
                                <li><b>Retail</b> → drives user acquisition through value, offers, and commerce.</li>
                                <li><b>Healthcare</b> → builds trust and daily relevance through real-world utility.</li>
                                <li><b>Content (ReelBOX, Music, Box)</b> → deepens engagement and platform stickiness.</li>
                                <li><b>Communication (Chime, Blog, Chat)</b> → sustains retention and community-driven activity.</li>
                            </ul>
                            <p style={{ fontSize: '0.84rem', lineHeight: '1.55', color: '#333', marginBottom: '9px' }}>
                                Together, these modules create a continuous engagement flywheel, where every interaction increases lifetime value, enhances monetization, and reduces acquisition costs — advantages that single-domain apps simply cannot match.
                            </p>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.93rem', marginBottom: '7px', fontWeight: 600 }}>Positioned Beyond Competition</h4>
                            <p style={{ fontSize: '0.84rem', lineHeight: '1.55', color: '#333', marginBottom: '9px' }}>
                                Conveyr is not competing with individual platforms such as Instagram, Netflix, or Flipkart.
                                Those are single-domain applications, built for isolated use cases. Conveyr operates beyond vertical boundaries, addressing the larger problem of digital fragmentation by bringing communication, content, commerce, and healthcare together — all in one place. <br />
                                Global leaders such as WeChat, Grab, and Paytm have already proven that convergence, not specialization, defines the next era of digital growth. Conveyr is building that future for India and beyond.
                            </p>
                            <h4 style={{ color: '#7b1fa2', fontSize: '0.93rem', marginBottom: '7px', fontWeight: 600 }}>Built for Scalability, Designed for Impact</h4>
                            <p style={{ fontSize: '0.84rem', lineHeight: '1.55', color: '#333', marginBottom: 0 }}>
                                Conveyr should be evaluated for its ecosystem potential, not simplified into a single-product narrative. Its architecture is built to compound growth across modules, amplify revenue streams, and create a digital environment where value multiplies — not divides.<br />
                                The question is not whether each module can stand on its own, but how much more powerful they become when combined. Conveyr’s ecosystem is engineered to scale — intelligently, sustainably, and exponentially.
                            </p>
                        </div>
                        <div style={{
                        flex: 1,
                        minWidth: "400px",
                        maxWidth: "650px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                        }}>
                        <img src={require('../assets/pp1.png')}
                            alt="Modules Contributing to Conveyr"
                            style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: 12,
                            boxShadow: "0 4px 14px rgba(120,0,90,0.15)"
                            }}
                        />
                        <div style={{ color: "#7b1fa2", fontSize: "0.9rem", textAlign: "center", marginTop: 10 }}>
                            Module Synergy Illustration
                        </div>
                        </div>
                    </div>
                    {/* End Additive Section */}

                    {/* Phase 1 Section */}
                    <div style={{ marginBottom: '40px' }}>
                        <h2 style={{ color: '#A40000', fontSize: '1.4rem', marginBottom: '20px', fontWeight: 'bold' }}>
                            Phase I: Core Module - Social Media & Entertainment - Live in Stores
                        </h2>

                        <div
                            style={{
                                color: '#222',
                                fontSize: "0.85rem",
                                fontWeight: 600,
                                fontStyle: 'normal',
                                lineHeight: 1.6,
                                marginBottom: 11
                            }}
                        >
                            Conveyr – India’s AI-Powered, Sovereign Digital Ecosystem<br />
                            Conveyr is India’s first truly comprehensive, AI-powered digital ecosystem—built entirely in India, for India—to empower individuals, businesses, communities, and government institutions on one secure, homegrown platform.
                            More than a social media application, Conveyr is a national digital infrastructure designed to protect data, amplify voices, and create opportunities across communication, entertainment, commerce, healthcare, finance, and cloud services.<br />
                            At its foundation, Conveyr rests on three core pillars;
                        </div>

                        {/* PHASE-1 MODULE GRID WITH MODAL */}
                        <div
                            style={{
    flex: 1,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",   // ✅ vertical center
  }}
                        >
                            {phase1Modules.map((module, index) => (
                                <ModalTrigger
                                    key={index}
                                    module={module}
                                    description={phase1Desc[index]}
                                    
                                />
                            ))}
                        </div>
                    </div>


                    {/* Phase 2 Section */}
                    <div style={{ marginBottom: '40px' }}>
                        <h2 style={{ color: '#A40000', fontSize: '1.4rem', marginBottom: '20px', fontWeight: 'bold' }}>Phase 2: Advanced Services & Enterprise Solutions</h2>
                        <div style={{
                            color: '#222',
                            fontSize: "0.85rem",
                            fontStyle: 'normal',
                            fontWeight: 600,
                            lineHeight: 1.6,
                            marginBottom: 11
                        }}>
                            Beyond Social Media – A Complete Digital Universe<br />
                            Conveyr goes far beyond traditional social networking by integrating a wide spectrum of services into a single, unified platform. While global platforms fragment user experience across multiple apps, Conveyr unifies it through advanced AI and an India-first design approach.
                        </div>
                        {/* PHASE II ILLUSTRATION */}
                        <div style={{ textAlign: "center", margin: "0 0 16px 0" }}>
                            <img
                                src={require('../assets/DS5.jpg')}
                                alt="Phase II AI/DS Contribution"
                                style={{
                                    width: "100%",
                                    maxWidth: 360,
                                    height: "auto",
                                    borderRadius: 10,
                                    marginBottom: 4,
                                    boxShadow: "0 2px 8px rgba(60,10,90,0.13)",
                                }}
                            />
                            <div style={{ color: "#A40000", fontSize: "0.81rem", marginTop: 3 }}>AI in Action — Phase II</div>
                        </div>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '10px',
                            justifyItems: 'stretch'
                        }}>
                            {phase2Modules.map((module, index) =>
                                module.isVeritasVogue ? (
                                    <div
                                        key={index}
                                        style={{
                                            background: 'black',
                                            color: 'gold',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            fontSize: '0.75rem',
                                            fontWeight: '500',
                                            boxShadow: '0 2px 6px rgba(218,165,32,0.10)',
                                            transition: 'background-color 0.5s ease, color 0.5s ease',
                                            border: '1px solid gold',
                                            textAlign: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '6px',
                                            minHeight: 110
                                        }}
                                    >
                                        {module.logo && (
                                            <img
                                                src={require(`../assets/${module.logo}`)}
                                                alt={module.name}
                                                style={{
                                                    width: '70px',
                                                    height: '70px',
                                                    objectFit: 'contain',
                                                    marginBottom: 6
                                                }}
                                            />
                                        )}
                                        <span>{module.name}</span>
                                        <span style={{
                                            color: colorToggle ? "white" : "gold",
                                            fontSize: "0.77rem",
                                            marginTop: "3px",
                                            whiteSpace: "normal"
                                        }}>{phase2Desc[index]}</span>
                                        <span style={{ fontStyle: 'italic', fontSize: '0.85em', color: 'gold', marginTop: 4 }}>
                                            {module.tagline}
                                        </span>
                                    </div>
                                ) : (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: colorToggle ? '#6A1B9A' : 'white',
                                            color: colorToggle ? 'white' : '#333',
                                            padding: '12px',
                                            borderRadius: '6px',
                                            fontSize: '0.75rem',
                                            fontWeight: '500',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                            transition: 'background-color 0.5s ease, color 0.5s ease',
                                            border: '1px solid #ddd',
                                            textAlign: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '6px',
                                            minHeight: 110
                                        }}
                                    >
                                        {module.logo && (
                                            <img
                                                src={require(`../assets/${module.logo}`)}
                                                alt={module.name}
                                                style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                                            />
                                        )}
                                        <span>{module.name}</span>
                                        <span style={{
                                            color: colorToggle ? 'white' : "#666",
                                            fontSize: "0.77rem",
                                            marginTop: "3px",
                                            whiteSpace: "normal"
                                        }}>{phase2Desc[index]}</span>
                                    </div>
                                )
                            )}
                        </div>
                        <div style={{ fontWeight: 500, color: "#7b1fa2", fontSize: "0.85rem", marginTop: 18 }}>
                            Together, these modules transform Conveyr from an app into a digital nation—a place where communication, commerce, creativity, entertainment, and essential services coexist seamlessly.
                        </div>
                    </div>
                </div>
                {/* Right Sidebar - 30% - Sticky Ecosystem Graphic */}
                <div style={{ flex: '0 0 30%', maxWidth: '30%', top: '10px', alignSelf: 'flex-start', maxHeight: 'calc(100vh - 20px)', overflow: 'visible' }}>
                    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <h3 style={{ color: '#7b1fa2', fontSize: '0.95rem', marginBottom: '2px', textAlign: 'center', fontWeight: 'bold' }}>Conveyr - Digital Ecosystem</h3>
                        <p style={{ color: '#6A1B9A', fontSize: '0.7rem', marginBottom: '5px', textAlign: 'center', fontWeight: '600' }}>AI-Powered Intelligence</p>

                        {/* SVG Graphic - Rotating Modules */}
                        <svg viewBox="0 0 400 380" style={{ width: '100%', height: 'auto' }}>
                            <defs>
                                <radialGradient id="conveyrgradient">
                                    <stop offset="0%" style={{ stopColor: '#9C27B0', stopOpacity: 1 }} />
                                    <stop offset="100%" style={{ stopColor: '#7b1fa2', stopOpacity: 1 }} />
                                </radialGradient>
                                <linearGradient id="metallicpurple" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" style={{ stopColor: '#9C27B0', stopOpacity: 1 }} />
                                    <stop offset="50%" style={{ stopColor: '#BA68C8', stopOpacity: 1 }} />
                                    <stop offset="100%" style={{ stopColor: '#7B1FA2', stopOpacity: 1 }} />
                                </linearGradient>
                                <path id="circlePathTop" d="M 30,190 A 160,160 0 0,1 370,190" fill="none" />
                                <path id="circlePathBottom" d="M 370,190 A 160,160 0 0,1 30,190" fill="none" />
                            </defs>
                            <rect x="0" y="0" width="400" height="380" fill="white" />
                            <g>
                                <animateTransform
                                    attributeName="transform"
                                    attributeType="XML"
                                    type="rotate"
                                    from="0 200 190"
                                    to="360 200 190"
                                    dur="12s"
                                    repeatCount="indefinite"
                                />
                                <circle cx="200" cy="190" r="180" fill="none" stroke="#7B1FA2" strokeWidth="2" strokeDasharray="5,5" />
                                <text fill="#7B1FA2" fontSize="9" fontWeight="bold">
                                    <textPath href="#circlePathTop" startOffset="0%">
                                        ARTIFICIAL INTELLIGENCE • ARTIFICIAL INTELLIGENCE •
                                    </textPath>
                                </text>
                                <text fill="#7B1FA2" fontSize="9" fontWeight="bold">
                                    <textPath href="#circlePathBottom" startOffset="0%">
                                        ARTIFICIAL INTELLIGENCE • ARTIFICIAL INTELLIGENCE •
                                    </textPath>
                                </text>
                            </g>
                            <circle cx="200" cy="190" r="150" fill="none" stroke="#9C27B0" strokeWidth="2.5" />
                            <g>
                                <animateTransform
                                    attributeName="transform"
                                    attributeType="XML"
                                    type="rotate"
                                    from="0 200 190"
                                    to="360 200 190"
                                    dur="8s"
                                    repeatCount="indefinite"
                                />
                                <circle cx="200" cy="190" r="45" fill="url(#conveyrgradient)" stroke="#7b1fa2" strokeWidth="2.5" />
                                <text x="200"
                                    y="194" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Conveyr</text>
                            </g>
                            <g>
                                <animateTransform
                                    attributeName="transform"
                                    attributeType="XML"
                                    type="rotate"
                                    from="0 200 190"
                                    to="360 200 190"
                                    dur="20s"
                                    repeatCount="indefinite"
                                />
                                {/* Chime - 0° */}
                                <g>
                                    <circle cx="305" cy="190" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="245" y1="190" x2="287" y2="190" stroke="#666" strokeWidth="1.5" />
                                    <text x="305" y="194" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Chime</text>
                                </g>
                                {/* Blog - 30° */}
                                <g>
                                    <circle cx="291" cy="243" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="238" y1="213" x2="276" y2="232" stroke="#666" strokeWidth="1.5" />
                                    <text x="291" y="247" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Blog</text>
                                </g>
                                {/* Chat - 60° */}
                                <g>
                                    <circle cx="253" cy="283" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="218" y1="228" x2="240" y2="270" stroke="#666" strokeWidth="1.5" />
                                    <text x="253" y="287" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Chat</text>
                                </g>
                                {/* Music - 90° */}
                                <g>
                                    <circle cx="200" cy="305" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="200" y1="240" x2="200" y2="287" stroke="#666" strokeWidth="1.5" />
                                    <text x="200" y="309" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Music</text>
                                </g>
                                {/* ReelBOX - 120° */}
                                <g>
                                    <circle cx="147" cy="283" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="182" y1="228" x2="160" y2="270" stroke="#666" strokeWidth="1.5" />
                                    <text x="147" y="285" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">Reel</text>
                                    <text x="147" y="291" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">BOX</text>
                                </g>
                                {/* Games - 150° */}
                                <g>
                                    <circle cx="109" cy="243" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="162" y1="213" x2="124" y2="232" stroke="#666" strokeWidth="1.5" />
                                    <text x="109" y="247" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Games</text>
                                </g>
                                {/* Health - 180° */}
                                <g>
                                    <circle cx="95" cy="190" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="155" y1="190" x2="113" y2="190" stroke="#666" strokeWidth="1.5" />
                                    <text x="95" y="194" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Health</text>
                                </g>
                                {/* News - 210° */}
                                <g>
                                    <circle cx="109" cy="137" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="162" y1="167" x2="124" y2="148" stroke="#666" strokeWidth="1.5" />
                                    <text x="109" y="141" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">News</text>
                                </g>
                                {/* Drive12 - 240° */}
                                <g>
                                    <circle cx="147" cy="97" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="182" y1="152" x2="160" y2="110" stroke="#666" strokeWidth="1.5" />
                                    <text x="147" y="96" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">Drive</text>
                                    <text x="147" y="102" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">12</text>
                                </g>
                                {/* Box - 270° */}
                                <g>
                                    <circle cx="200" cy="75" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="200" y1="140" x2="200" y2="93" stroke="#666" strokeWidth="1.5" />
                                    <text x="200" y="79" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Box</text>
                                </g>
                                {/* Finance - 300° */}
                                <g>
                                    <circle cx="253" cy="97" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="218" y1="152" x2="240" y2="110" stroke="#666" strokeWidth="1.5" />
                                    <text x="253" y="96" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">Fin-</text>
                                    <text x="253" y="102" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">ance</text>
                                </g>
                                {/* Ecommerce - 330° */}
                                <g>
                                    <circle cx="291" cy="137" r="18" fill="url(#metallicpurple)" stroke="#9C27B0" strokeWidth="1.5" />
                                    <line x1="238" y1="167" x2="276" y2="148" stroke="#666" strokeWidth="1.5" />
                                    <text x="291" y="136" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">Ecom-</text>
                                    <text x="291" y="142" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">merce</text>
                                </g>
                            </g>
                        </svg>
                        
                    </div>
                </div>
            </div>
            {/* ----- Footer ----- */}
            <footer
  style={{
    padding: "2rem 1.5rem",
    textAlign: "center",
    background: "#fff",
    marginTop: "1rem",
    borderTop: "1px solid #e0e0e0",
  }}
>
  {/* COMPANY */}
  <p style={{ margin: "0 0 0.6rem 0", fontWeight: 600 }}>
    © 2025 Algebracorp OPC Private Limited
  </p>

  {/* ADDRESS */}
  <p style={{ margin: "0 0 1.2rem 0", fontSize: "0.9rem", color: "#555" }}>
    Office Address: 16th Park View, Gaur Yamuna City Greater Noida. Up
  </p>

  {/* SOCIAL ICONS */}
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "1.4rem",
      marginBottom: "1rem",
    }}
  >
    {/* WhatsApp */}
    <a
      href="https://wa.me/+917518410292"
      target="_blank"
      rel="noopener noreferrer"
      title="WhatsApp"
      style={{ display: "inline-flex" }}
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        style={{
          height: "28px",
          width: "28px",
          transition: "transform 0.25s ease",
        }}
        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
      />
    </a>

    {/* Instagram */}
    <a
      href="https://www.instagram.com/algebracorp"
      target="_blank"
      rel="noopener noreferrer"
      title="Instagram"
      style={{ display: "inline-flex" }}
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
        alt="Instagram"
        style={{
          height: "28px",
          width: "28px",
          transition: "transform 0.25s ease",
        }}
        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
      />
    </a>

  </div>

  {/* TAGLINE */}
  <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
    Building India’s Next-Generation Digital & Commerce Ecosystems
  </p>
</footer>
        </div>
    );
};

export default Product;







